import style from './Footer.module.css'
import {Link, useLocation} from 'react-router-dom';
import bale from "../Assets/social media/bale-svgrepo-com.svg"
import eitaa from "../Assets/social media/eitaa-svgrepo-com (1).svg"
import telegram from "../Assets/social media/telegram-svgrepo-com.svg"
import { useState } from 'react';
import instagram from "../Assets/social media/instagram-1-svgrepo-com.svg"
import logo from "../Assets/logo/logo.png"

export default function Footer() {

    const [currentLanguage, setCurrentLanguage] = useState(() => {
      return localStorage.getItem('siteLanguage') || localStorage.getItem('fa') || 'ar';
    });

    return (
  <>
    {currentLanguage === 'fa' ? (
      // Persian Version
      <div className={style.footer}>
        <div className={style.parentContainer}>
          <div className={style.mainCContainer}>
            <div className={style.firstFooter}>
              <div className={style.footerContent}>
                <div className={style.footerRight}>
                  <div className={style.logo}>
                    <Link to='/'>
                      <img src={logo} alt="Logo" />
                    </Link>
                  </div>
                  <div className={style.footerTextRight}>
                    <p>
                      سید حسن نَصْرالله (۱۳۳۹-۱۴۰۳ش) ملقب به سید مقاومت روحانی و سیاستمدار شیعه اهل لبنان، سومین دبیرکل حزب‌الله لبنان و از بنیانگذاران آن بود. حزب‌الله در دوران دبیرکلی وی‌ (از سال ۱۹۹۲م-۲۰۲۴م) به قدرتی منطقه‌ای تبدیل شد. آزادسازی جنوب لبنان در ۲۰۰۰م از اشغال رژیم صهیونیستی، آزادی اسیران لبنانی و بازپس‌گیری اجساد شهدای مقاومت از دست اسرائیل در ۲۰۰۴م و پیروزی در جنگ ۳۳ روزه در ۲۰۰۶م در زمان دبیرکلی نصرالله روی داد. او به دلیل مقاومت و پیروزی‌های چندباره در برابر اسرائیل، محبوب‌ترین و قدرتمندترین رهبرِ جهان عرب شناخته می‌شود.
                    </p>
                  </div>
                </div>
                <div className={style.footerMid}>
                  <div className={style.mid}>
                    <h3>دسترسى سريع</h3>
                    <div className={style.linkContainer}>
                      <ul className={style.links}>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                      </ul>
                      <ul className={style.links}>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                      </ul>
                    </div>
                  </div>
                  <div className={style.mid}>
                    <h3>دسترسى سريع</h3>
                    <div className={style.linkContainer}>
                      <ul className={style.links}>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                      </ul>
                      <ul className={style.links}>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={style.footerLeft}>
                  <h3>حزب‌:3853</h3>
                  <div className={style.socialMedia}>
                    <div className={style.socials}>
                      <a href='https://t.me/nasrollah_info' target='_blank'><img src={telegram} /></a>
                    </div>
                    <div className={style.socials}>
                      <a href='https://www.aparat.com/nasrollah_info' target='_blank'><img src={'https://cdn.nasrollah.info/icons8-aparat-96.webp'} /></a>
                    </div>
                    <div className={style.socials}>
                      <a href='https://www.eitaa.com/nasrollah_info' target='_blank'><img src={eitaa} /></a>
                    </div>
                    <div className={style.socials}>
                      <img src={instagram} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={style.miniFooter}>
            <div className={style.contMiniFooter}>
              <div className={style.miniRight}>
                <span> كليه حقوق اين سايت متعلق به نصرالله اينفو مي باشد</span>
              </div>
              <div className={style.miniFooterIcon}>
                <a href='https://t.me/nasrollah_info' target='_blank'><img src={telegram} /></a>
                <a href='https://www.aparat.com/nasrollah_info' target='_blank'><img src={'https://cdn.nasrollah.info/icons8-aparat-96.webp'} /></a>
                <a href='https://www.eitaa.com/nasrollah_info' target='_blank'><img src={eitaa} /></a>
                <a href='instagram'><img src={instagram} /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      // Arabic Version 
      <div className={style.footer}>
        <div className={style.parentContainer}>
          <div className={style.mainCContainer}>
            <div className={style.firstFooter}>
              <div className={style.footerContent}>
                <div className={style.footerRight}>
                  <div className={style.logo}>
                    <Link to='/'>
                      <img src={logo} alt="شعار" />
                    </Link>
                  </div>
                  <div className={style.footerTextRight}>
                    <p>
                      السيد حسن نصرالله (١٩٦٠-٢٠٢٤م) الملقب بسيد المقاومة، رجل دين وسياسي شيعي لبناني، الأمين العام الثالث لحزب الله اللبناني ومن مؤسسيه. تحول حزب الله في عهد أمانته العامة (من عام ١٩٩٢م-٢٠٢٤م) إلى قوة إقليمية. حدث تحرير جنوب لبنان في عام ٢٠٠٠م من احتلال النظام الصهيوني، وتحرير الأسرى اللبنانيين واسترداد جثامين شهداء المقاومة من إسرائيل في ٢٠٠٤م، والانتصار في حرب الـ٣٣ يوماً في ٢٠٠٦م خلال فترة أمانة نصرالله العامة.
                    </p>
                  </div>
                </div>
                <div className={style.footerMid}>
                  <div className={style.mid}>
                    <h3> وصول سريع </h3>
                    <div className={style.linkContainer}>
                      <ul className={style.links}>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                      </ul>
                      <ul className={style.links}>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                      </ul>
                    </div>
                  </div>
                  <div className={style.mid}>
                    <h3> روابط مهمة </h3>
                    <div className={style.linkContainer}>
                      <ul className={style.links}>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                      </ul>
                      <ul className={style.links}>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                        <li><a href="#">حزب الله</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={style.footerLeft}>
                  <h3> الحزب: ٣٨٥٣ </h3>
                  <div className={style.socialMedia}>
                    <div className={style.socials}>
                      <a href='https://t.me/nasrollah_info' target='_blank'><img src={telegram} /></a>
                    </div>
                    <div className={style.socials}>
                      <a href='https://www.aparat.com/nasrollah_info' target='_blank'><img src={'https://cdn.nasrollah.info/icons8-aparat-96.webp'} /></a>
                    </div>
                    <div className={style.socials}>
                      <a href='https://www.eitaa.com/nasrollah_info' target='_blank'><img src={eitaa} /></a>
                    </div>
                    <div className={style.socials}>
                      <img src={instagram} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={style.miniFooter}>
            <div className={style.contMiniFooter}>
              <div className={style.miniRight}>
                <span> جميع الحقوق محفوظ الموقع نصرالله اينفو </span>
              </div>
              <div className={style.miniFooterIcon}>
                <a href='https://t.me/nasrollah_info' target='_blank'><img src={telegram} /></a>
                <a href='https://www.aparat.com/nasrollah_info' target='_blank'><img src={'https://cdn.nasrollah.info/icons8-aparat-96.webp'} /></a>
                <a href='https://www.eitaa.com/nasrollah_info' target='_blank'><img src={eitaa} /></a>
                <a href='instagram'><img src={instagram} /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </>
    );}